module.exports = __webpack_public_path__ + "img/caret-down--light.671f62d8.svg";